(function () {
  var sliders = document.querySelectorAll("[data-lifestyle-swiper]");

  if (!sliders.length || typeof Swiper === "undefined") {
    return;
  }

  sliders.forEach(function (slider) {
    new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: 14,
      watchOverflow: true,
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        769: {
          spaceBetween: 14,
        },
      },
    });
  });
})();
